export enum RegistrationFlow {
    MEMBERSHIP_VERIFICATION,
    METHOD_SELECTION,
    PHONE_REGISTRATION
};